import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle } from 'lucide-react';

interface ResetConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isResetting: boolean;
}

export const ResetConfirmationDialog: React.FC<ResetConfirmationDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isResetting,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            <DialogTitle>Reset Conversation?</DialogTitle>
          </div>
          <DialogDescription className="pt-2 space-y-2">
            <p>
              This will clear the AI's memory of this conversation. The next message will start with a fresh context.
            </p>
            <p className="text-sm">
              <strong>Note:</strong> Your chat history will remain visible in the interface, but the AI won't have access to it.
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isResetting}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isResetting}
          >
            {isResetting ? 'Resetting...' : 'Reset Conversation'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
